import { Component, OnInit } from '@angular/core';

import { STATIC_VALUE } from './../../shared/configuration/static.value';

import { RegisterService } from '../services/register.service';

import { ErrorService } from '../../shared/services/error.service';
import { LayoutService } from '../../shared/services/layout.service';

@Component({
    selector: 'login-register',
    templateUrl: 'register.component.html'
})

export class LoginRegisterComponent implements OnInit{
    constructor(
        private _registerService: RegisterService, 
        private _errorService: ErrorService,
        private _layoutService: LayoutService,
    ) {
        
    }

    ngOnInit() {
    	this._layoutService.setCurrentPage('login-register');
        this._registerService.resetError();
        this._registerService.resetRegistrationData();
    }

    register(){
        this._registerService.userRegister();
    }

    getRegistrationData(){
        return this._registerService.getRegisterData();
    }

    getErrorStatusAndMessage(){
        return this._errorService.getErrorStatusAndMessage();
    }

    isDisableRegister(){
        return this._registerService.isDisableRegister();
    }

    isLoading(){
        return this._registerService.isLoading();
    }

    getSecurityQuestionList() {
		return STATIC_VALUE.SECURITY_QUESTION_LIST;
    }
}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/login/components/register.component.ts